import { Button, Card, CardContent, Table, TableRow, TableBody, TableCell, TableHead, CardHeader, Divider } from "@material-ui/core";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState, Fragment } from "react";
import moment from "moment";
import clsx from "clsx";
import { EmptyState } from 'components';
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
  },
  card: {
    marginTop: theme.spacing(2)
  },
  content: {
    padding: 0,
    paddingBottom: "0 !important"
  },
  inner: {
    minWidth: 700
  }
}));

const CalendarList = props => {
  const { slots } = props;
  const [days, setDays] = useState([]);
  const classes = useStyles()

  useEffect(() => {
    if (slots) {
      let new_days = [];
      slots.forEach(slot => {
        let start_at = moment(slot.start_at);
        let date = start_at.date();
        let month = start_at.month();
        let year = start_at.year();
        let day = new_days.find(d => d.date === date && d.month === month);
        if (!day) {
          day = { date, month, year, slots: [] };
          new_days.push(day);
        }
        day.slots.push(slot);
      });
      setDays(new_days);
    }
  }, [slots])

  return (
    <Fragment>
      {days && days.map((day, index) => {
        let { date, month, year } = day;
        return (
          <Card
            // {...rest}
            key={index}
            className={clsx(classes.root)}
          >
            <CardHeader title={moment(`${year}${month + 1}${date}`, "YYYYMMDD").format("D MMM YYYY")} />
            <Divider />
            <CardContent className={classes.content}>
              <PerfectScrollbar>
                <div className={classes.inner}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Time</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {day.slots.map((slot) => (
                        <TableRow key={slot.id}>
                          <TableCell>
                            {slot.name_en}{slot.name_zh ? " " + slot.name_zh : ""}
                          </TableCell>
                          <TableCell>{moment(slot.start_at).format("DD/MM/YYYY")}</TableCell>
                          <TableCell>{moment(slot.start_at).format("HH:mm")}</TableCell>
                          <TableCell>
                            {slot.duration / 60} min
                            </TableCell>
                          <TableCell align="right">
                            <Button color="primary" component={RouterLink} size="small" to={`/lesson_slots/${slot.id}/summary`} variant="outlined">
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </PerfectScrollbar>
            </CardContent>
          </Card>
        )
      })}
      <EmptyState variant="card" active={!days.length} message="You do not have any slots for this lesson this month" />
    </Fragment>
  )
}

export default CalendarList;